import { Feature, Map, View } from "ol";
import Attribution from "ol/control/Attribution";
import Control from "ol/control/Control";
import Zoom from "ol/control/Zoom";
import { platformModifierKeyOnly } from "ol/events/condition";
import { Point } from "ol/geom";
import { circular } from "ol/geom/Polygon";
import { defaults, DragPan, MouseWheelZoom } from "ol/interaction";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import { fromLonLat } from "ol/proj";
import { StadiaMaps } from "ol/source";
import VectorSource from "ol/source/Vector";
import Fill from "ol/style/Fill";
import Icon from "ol/style/Icon";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";

var local_selectors = {
    parkingMap: '#parking-map',
    parkingMapId: 'parking-map',
    parkingDatesForm: '#parking-dates-form',
    parkingReviewsModal: '#parking-reviews-modal',
    parkingModelsWrapper: '#parking-models-wrapper',
    locationBreadcrumbLink: '.location-bc-link'
};

//utilizzo questa variabile per identificare il primo caricamento dei risultati di ricerca
var firstLoad = true;
var centerMarker;
var map = null;
var parkingDatesTimeout = null;

if (!selectors) {
    var selectors = {};
}
Object.assign(selectors, local_selectors);

$(document).ready(function () {    
    updateLocationBc();

    //al caricamento della pagina se il parametro reviews è true apro il pannello delle reviews
    if ($.urlParam('reviews')) {
        $(selectors.parkingReviewsModal).modal('show');
    };

    $('body').on('submit', selectors.parkingDatesForm, function (e) {
        e.preventDefault();
        var sender = $(this);
        sender.addClass('ajax-dates');
        udateParkingModelsTable(sender);
    });

    $('body').on('change', selectors.parkingDatesForm + '.ajax-dates', function (e) {
        e.preventDefault();
        var sender = $(this);
        if (parkingDatesTimeout) {
            clearTimeout(parkingDatesTimeout);
        }
        parkingDatesTimeout = setTimeout(function () {
            lock($(selectors.parkingModelsWrapper));
            udateParkingModelsTable(sender);
        }, 700);
    });

    //al click del link della location nel breadcrumb riporto l'utente alla pagina precedente SOLO SE provengo da una pagina di risultati di ricerca
    //altrimenti rimando alla pagina della location
    $('body').on('click', selectors.locationBreadcrumbLink, function (e) {
        e.preventDefault();
        var sender = $(this),
            referrer = document.referrer;
        if (referrer && referrer.includes('/site/results')) {
            //evito l'history back per mantenere un history coerente con la navigazione
            window.location.href = referrer;
        }
        else {
            window.location.href = sender.attr('href');
        }
    });

    document.dispatchEvent(new Event("parkingDetailsStandaloneLoaded"));

    initOpenlayers();
});

function udateParkingModelsTable(form) {
    var data = form.serializeArray();
    data.push({
        name: 'from',
        value: 'parking-standalone'
    });
    lock(form);
    $.ajax({
        url: form.attr('action'),
        data: data,
        method: 'GET',
        success: function (result) {
            if (result) {
                var url = '/site/parking?' + form.serialize();
                updateUrl(url);
                $(selectors.parkingModelsWrapper).html(result);
                var availableCouter = $(result).find('.parking-model-detail-btn:not(.disabled)').length;
                if (availableCouter > 0) {
                    $('.no-results').addClass('d-none');
                }
                else {
                    $('.no-results').removeClass('d-none');
                }
                form.find('button[type="submit"]').attr('disabled', 'disabled');
                form.find('button[type="submit"]').fadeOut();
                document.dispatchEvent(new Event("parkingDetailsStandaloneLoaded"));
                updateLocationBc();
            }
            else {
                // pmcToast('Inserire data di check-in e di check-out.', 'danger', true);
                form.find('button[type="submit"]').removeAttr('disabled');
                form.find('button[type="submit"]').fadeIn();
            }
            unlock($(selectors.parkingModelsWrapper));
        },
        error: function () {
            pmcDialog.alert('Si è verificato un errore, riprova più tardi.');
        },
        complete: function () {
            unlock(form);
        }
    });
}

function updateLocationBc() {
    var form = $(selectors.parkingDatesForm),
        locationLink = $(selectors.locationBreadcrumbLink).attr('href').split('?')[0];
    var serializedData = form.serialize();
    var cleanedQueryString = cleanQueryString(serializedData);
    $(selectors.locationBreadcrumbLink).attr('href', locationLink + (cleanedQueryString ? '?' + cleanedQueryString : ''));
}


//funzione che imposta il marker al centro della mappa
function setCenterMarker() {
    if (centerMarker) {
        centerMarker.setMap(null);
    }
    centerMarker = new google.maps.Marker({
        position: map.getCenter(),
        zIndex: 0,
        icon: {
            url: "/images/map_center.svg",
            anchor: new google.maps.Point(40, 40)
        }
        // clickable:false
    });
    // aggiungo il marker alla mappa
    centerMarker.setMap(map);
}

//funzione per aggiornare l'url nella barra degli indirizzi
function updateUrl(url = getSearchUrl(), type = null) {
    history.pushState({
        'url': url,
        'type': type
    }, "", url);
}

//funzione che restituisce l'url di ricerca con i parametri del seaarchForm corrente
function getSearchUrl(params = {}, toParkingDetail = false) {
    //escludo dall'url i parametri vuoti ed il message che non mi serve
    var inputs = $(selectors.searchForm + ' :input[value!=""][value!=" "][value!=0][name!="SearchForm[message]"]').serializeArray();
    var url = '/site/results',
        first = true,
        inputParams = {};

    if (toParkingDetail) {
        url = '/site/parking'
    }

    for (i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.value != '' && input.value != 0 && input.value != false) {
            inputParams[input.name] = input.value;
        }
    }

    //sostituisco i parametri nella form con quelli passati alla funzione dove presenti
    $.each(params, function (key, value) {
        inputParams[key] = value;
    });

    $.each(inputParams, function (key, value) {
        if (value != '' && value != 0 && value != false) {
            if (first) {
                url += '?';
                first = false;
            } else {
                url += '&'
            }
            url += key + '=' + value;
        }
    });

    return url;
}

function initOpenlayers() {
    var center = [$(selectors.parkingMap).data('lng'), $(selectors.parkingMap).data('lat')];
    var zoom = $(selectors.parkingMap).data('zoom');
    var url = $(selectors.parkingMap).data('url');
    var min_z = $(selectors.parkingMap).data('min-z');
    var max_z = $(selectors.parkingMap).data('max-z');

    const source = new StadiaMaps({
        url: url,
        layer: 'osm_bright',
        retina: true,
        minZoom: min_z,
        maxZoom: max_z,
    });

    //layer Stadia
    let stadiaLayer = new TileLayer({
        source: source,
        visible: true
    });


    let attribution = new Attribution({
        collapsible: false,
    });

    const geolocSource = new VectorSource();
    const geolocLayer = new VectorLayer({
        source: geolocSource,
    });


    let geolocReady = false;

    const locate = document.createElement('div');
    locate.className = 'ol-control ol-unselectable ol-locate';
    locate.innerHTML = '<button title="Posizione attuale"><i class="ti ti-focus-2"></i></button>';
    locate.addEventListener('click', function () {

        if (geolocReady) {
            if (!geolocSource.isEmpty()) {
                map.getView().fit(geolocSource.getExtent(), {
                    maxZoom: 18,
                    duration: 500,
                });
            }
        }
        else {
            initGeoloc(function () {
                if (!geolocSource.isEmpty()) {
                    map.getView().fit(geolocSource.getExtent(), {
                        maxZoom: 18,
                        duration: 500,
                    });
                }
            });
        }
    });

    var geolocStyle = new Style({
        fill: new Fill({
            color: '#fff',
            weight: 1
        }),
        stroke: new Stroke({
            color: '#fc8030',
            width: 5
        })
    });

    function initGeoloc(callback = null) {
        navigator.geolocation.watchPosition(
            function (pos) {
                const coords = [pos.coords.longitude, pos.coords.latitude];
                const accuracy = circular(coords, 3);
                geolocSource.clear(true);
                geolocSource.addFeatures([
                    new Feature(
                        accuracy.transform('EPSG:4326', map.getView().getProjection())
                    ),
                    new Feature(new Point(fromLonLat(coords))),
                ]);
                callback();
                geolocReady = true;
            },
            function (error) {
                pmcToast('È necessario consentire l\'accesso alla posizione del dispositivo.', 'danger', true);
            },
            {
                enableHighAccuracy: true,
            }
        );
    }

    map = new Map({
        target: 'parking-map',
        layers: [
            stadiaLayer
        ],
        view: new View({
            center: fromLonLat(center),
            zoom: zoom
        }),
        controls: [
            attribution,
            new Control({
                element: locate,
            }),
            new Zoom()
        ],
        interactions: defaults({
            doubleClickZoom: false,
            dragAndDrop: false,
            dragPan: false,
            mouseWheelZoom: false,
            select: false
        }).extend([
            new DragPan({
                condition: function (event) {
                    return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
                }
            }),
            new MouseWheelZoom({
                condition: platformModifierKeyOnly,
            }),
        ]),
    });

    //aggiungo il pin al centro della mappa
    const vectorSource = new VectorSource();
    vectorSource.addFeatures([new Feature(new Point(fromLonLat(center)))]);
    let pinLayer = new VectorLayer({
        source: vectorSource,
        style: new Style({
            image: new Icon({
                src: '/images/map_center.svg'
            })
        })
    });
    map.addLayer(pinLayer);

    geolocLayer.setStyle(geolocStyle);
    map.addLayer(geolocLayer);

    //funzione per collassare le attribution della mappa sui formati mobile
    function checkSize() {
        const small = map.getSize()[0] < 600;
        attribution.setCollapsible(small);
        attribution.setCollapsed(small);
    }

    map.on('change:size', checkSize);
    checkSize();
}

function loadParkingReviews(parkingId) {
    var modal = $('#parking-reviews-modal');
    var content = $('#reviews-modal-content');
    var loaded = modal.data('loaded');

    if (loaded) {
        return;
    }

    modal.data('loaded', true);
    lock(content);
    $.ajax({
        url: '/parking/reviews',
        method: 'GET',
        data: { id: parkingId },
        success: function (html) {
            if (html) {
                content.html(html);
            } else {
                content.html('<p class="text-danger">Impossibile caricare le recensioni</p>');
            }
        },
        error: function () {
            content.html('<p class="text-danger">Si è verificato un errore, riprova più tardi</p>');
        },
        complete: function () {
            unlock(content);
        }
    });
}

$(selectors.parkingReviewsModal).on('show.bs.modal', function (event) {
    var parkingId = $(selectors.parkingReviewsModal).data('parking-id');
    loadParkingReviews(parkingId);
});
